import { Injectable } from '@angular/core';
import { Params } from '@angular/router';

import { Observable } from 'rxjs';
import { AuthService } from 'src/app/auth/services/auth.service';

import { EndPointService } from 'src/app/core/services/end-point.service';
import { Task } from '../models/Task';
import { TaskOverview } from '../models/TaskOverview';
import { TaskSetting, TaskSettingDetailActor, TaskSettingsSave } from '../models/TaskSetting';
import { ManagerScope } from '../../home-pages/manager-hr-dashboard/models/TeamMemberRequest';

@Injectable({
  providedIn: 'root',
})
export class TasksService {
  private _baseUrl = '/api/framework/ESSTasks/';
  private _delegateTaskUrl = 'getdelegatetasks';
  private myTaskDetail: Task;

  private taskReview: Task;

  private _courseConfirmDetailUrl = 'detail/courseconfirm';
  private _courseConfirmTeamDetailUrl = 'detail/courseconfirmteam';
  private _preAssessmentDetailUrl = 'detail/preassessment';
  private _postAssessmentDetailUrl = 'detail/postassessment';
  private _courseEvalDetailUrl = 'detail/courseeval';
  private _courseEvalTeamDetailUrl = 'detail/courseevalteam';
  private _courseRequestDetailUrl = 'detail/courserequest';
  private _ownInformalConversationDetailUrl = 'detail/owninformalconversation';
  private _informalConversationTeamDetailUrl =
    'detail/informalconversationteam';
  private _certificateAssessmentDetailUrl = 'detail/certificateassessment';
  private _certificateRequirementConfirmationDetailUrl =
    'detail/certificaterequirementconfirmation';
  private _certificateTeamDetailUrl = 'detail/certificateteam';
  private _certificateResponsibleDetailUrl = 'detail/certificateresponsible';
  private _courseInPictureDetailUrl = 'detail/courseinpicture';
  private _bookmarkDetailUrl = 'detail/bookmark';
  private _plannedCourseDayDetailUrl = 'detail/plannedcourseday';
  private _positionFlowDetailUrl = 'detail/positionflow';
  private _SetReviewedByStudent = 'SetReviewedByStudent';
  private _notPresenceDetailUrl = 'detail/notpresence';
  private _downloadSessionDoclUrl = 'detail/downloadsessiondoc';

  private _baseUrlTaskSettings = '/api/framework/tasksettings/';
  private _saveUrlTaskSettings = 'SaveTaskSettings';
  private _essUrlTaskSettings = 'GetTaskSettingsDetail';
  private _essSaveUrlTaskSettings = 'SaveTaskSettingsDetail';

  constructor(
    private _endPointService: EndPointService,
    private _authService: AuthService
  ) {
    this.registerEndPoints();
  }

  private registerEndPoints(): void {
    this._endPointService.registerEndPoint<TaskSetting[]>(
      'GetTaskSettings',
      `${this._baseUrlTaskSettings}`,
      true
    );
    this._endPointService.registerEndPoint<string>(
      'SaveTaskSettings',
      `${this._baseUrlTaskSettings}${this._saveUrlTaskSettings}`,
      true
    );
    this._endPointService.registerEndPoint<TaskSettingDetailActor[]>(
      'GetTaskSettingsDetail',
      `${this._baseUrlTaskSettings}${this._essUrlTaskSettings}`,
      true
    );
    this._endPointService.registerEndPoint<string[]>(
      'SaveTaskSettingsDetail',
      `${this._baseUrlTaskSettings}${this._essSaveUrlTaskSettings}`,
      true
    );
    this._endPointService.registerEndPoint<TaskOverview>(
      'GetTasks',
      `${this._baseUrl}`,
      true
    );
    this._endPointService.registerEndPoint<TaskOverview>(
      'GetDelegateTasks',
      `${this._baseUrl}${this._delegateTaskUrl}`,
      true
    );
    this._endPointService.registerEndPoint<Task>(
      'GetCourseConfirmTaskDetail',
      `${this._baseUrl}${this._courseConfirmDetailUrl}`,
      true
    );
    this._endPointService.registerEndPoint<Task>(
      'GetNotPresenceTaskDetail',
      `${this._baseUrl}${this._notPresenceDetailUrl}`,
      true
    );
    this._endPointService.registerEndPoint<Task>(
      'GetCourseConfirmTeamTaskDetail',
      `${this._baseUrl}${this._courseConfirmTeamDetailUrl}`,
      true
    );
    this._endPointService.registerEndPoint<Task>(
      'GetPreAssessmentTaskDetail',
      `${this._baseUrl}${this._preAssessmentDetailUrl}`,
      true
    );
    this._endPointService.registerEndPoint<Task>(
      'GetPostAssessmentTaskDetail',
      `${this._baseUrl}${this._postAssessmentDetailUrl}`,
      true
    );
    this._endPointService.registerEndPoint<Task>(
      'GetCourseEvalTaskDetail',
      `${this._baseUrl}${this._courseEvalDetailUrl}`,
      true
    );
    this._endPointService.registerEndPoint<Task>(
      'GetCourseEvalTeamTaskDetail',
      `${this._baseUrl}${this._courseEvalTeamDetailUrl}`,
      true
    );
    this._endPointService.registerEndPoint<Task>(
      'GetCourseRequestTaskDetail',
      `${this._baseUrl}${this._courseRequestDetailUrl}`,
      true
    );
    this._endPointService.registerEndPoint<Task>(
      'GetOwnInformalConversationTaskDetail',
      `${this._baseUrl}${this._ownInformalConversationDetailUrl}`,
      true
    );
    this._endPointService.registerEndPoint<Task>(
      'GetCertificateAssessmentTaskDetail',
      `${this._baseUrl}${this._certificateAssessmentDetailUrl}`,
      true
    );
    this._endPointService.registerEndPoint<Task>(
      'GetInformalConversationTeamTaskDetail',
      `${this._baseUrl}${this._informalConversationTeamDetailUrl}`,
      true
    );
    this._endPointService.registerEndPoint<Task>(
      'GetPositionFlowTaskDetail',
      `${this._baseUrl}${this._positionFlowDetailUrl}`,
      true
    );
    this._endPointService.registerEndPoint<Task>(
      'GetCertificateRequirementConfirmationTaskDetail',
      `${this._baseUrl}${this._certificateRequirementConfirmationDetailUrl}`,
      true
    );
    this._endPointService.registerEndPoint<Task>(
      'GetCertificateTeamTaskDetail',
      `${this._baseUrl}${this._certificateTeamDetailUrl}`,
      true
    );
    this._endPointService.registerEndPoint<Task>(
      'GetCertificateResponsibleTaskDetail',
      `${this._baseUrl}${this._certificateResponsibleDetailUrl}`,
      true
    );
    this._endPointService.registerEndPoint<Task>(
      'GetCourseInPictureTaskDetail',
      `${this._baseUrl}${this._courseInPictureDetailUrl}`,
      true
    );
    this._endPointService.registerEndPoint<Task>(
      'GetBookmarkDetail',
      `${this._baseUrl}${this._bookmarkDetailUrl}`,
      true
    );
    this._endPointService.registerEndPoint<Task>(
      'GetPlannedCourseDayTaskDetail',
      `${this._baseUrl}${this._plannedCourseDayDetailUrl}`,
      true
    );
    this._endPointService.registerEndPoint(
      'SetReviewedByStudent',
      `${this._baseUrl}${this._SetReviewedByStudent}`,
      true
    );
    this._endPointService.registerEndPoint(
      'DownloadSessionDoc',
      `${this._baseUrl}${this._downloadSessionDoclUrl}`,
      false
    );
  }

  public getTasks(IsManagerActive: boolean, scope: ManagerScope, fetch?: boolean): Observable<TaskOverview> {
    if (localStorage.getItem('delegate_view') === '1') {
      const activeDelegation = this._authService.getActiveDelegation();
      if (!activeDelegation) {
        return this._endPointService.call<TaskOverview>('GetTasks', { IsManagerActive, scope }, fetch);
      }

      return this._endPointService.call<TaskOverview>(
        'GetDelegateTasks',
        activeDelegation.studentId,
        fetch
      );
    } else {
      return this._endPointService.call<TaskOverview>('GetTasks', { IsManagerActive, scope }, fetch);
    }
  }

  public getTaskDetail(
    category: number,
    params: Params,
    fetch?: boolean
  ): Observable<Task> {
    switch (category) {
      case 1:
        return this._endPointService.call<Task>(
          'GetCourseConfirmTaskDetail',
          params,
          fetch
        );
        break;
      case 2:
        return this._endPointService.call<Task>(
          'GetCourseConfirmTeamTaskDetail',
          params,
          fetch
        );
        break;
      case 4:
        return this._endPointService.call<Task>(
          'GetPreAssessmentTaskDetail',
          params,
          fetch
        );
        break;
      case 5:
        return this._endPointService.call<Task>(
          'GetPostAssessmentTaskDetail',
          params,
          fetch
        );
        break;
      case 6:
        return this._endPointService.call<Task>(
          'GetCourseEvalTaskDetail',
          params,
          fetch
        );
        break;
      case 7:
        return this._endPointService.call<Task>(
          'GetCourseEvalTeamTaskDetail',
          params,
          fetch
        );
        break;
      case 8:
        return this._endPointService.call<Task>(
          'GetPlannedCourseDayTaskDetail',
          params,
          fetch
        );
        break;
      case 9:
        return this._endPointService.call<Task>(
          'GetCourseRequestTaskDetail',
          params,
          fetch
        );
        break;
      case 13:
        return this._endPointService.call<Task>(
          'GetOwnInformalConversationTaskDetail',
          params,
          fetch
        );
        break;
      case 14:
        //20200929
        return this._endPointService.call<Task>(
          'GetInformalConversationTeamTaskDetail',
          params /*20200929 hier komt id terug */,

          fetch
        );

        break;
      case 19:
        return this._endPointService.call<Task>(
          'GetCertificateAssessmentTaskDetail',
          params,
          fetch
        );
        break;
      case 21:
        return this._endPointService.call<Task>(
          'GetCertificateRequirementConfirmationTaskDetail',
          params,
          fetch
        );
        break;
      case 23:
        return this._endPointService.call<Task>(
          'GetCertificateTeamTaskDetail',
          params,
          fetch
        );
        break;
      case 24:
        return this._endPointService.call<Task>(
          'GetCertificateResponsibleTaskDetail',
          params,
          fetch
        );
        break;
      case 26:
        return this._endPointService.call<Task>(
          'GetCourseInPictureTaskDetail',
          params,
          fetch
        );
        break;
      case 27:
        return this._endPointService.call<Task>(
          'GetBookmarkDetail',
          params,
          fetch
        );
        break;
      case 31:
        return this._endPointService.call<Task>(
          'GetPositionFlowTaskDetail',
          params,
          fetch
        );
        break;
      case 32:
        return this._endPointService.call<Task>(
          'GetNotPresenceTaskDetail',
          params,
          fetch
        );
        break;

      default:
        return this._endPointService.call<Task>('', params, fetch);
        break;
    }
    // return myTaskDetail;
  }

  public getMyTaskDetailObject(): Task {
    return this.myTaskDetail;
  }

  public setMyTaskDetailObject(task: Task) {
    this.myTaskDetail = task;
  }

  public getTaskSettings(fetch?: boolean) {
    return this._endPointService.call<TaskSetting[]>(
      'GetTaskSettings',
      null,
      fetch
    );
  }

  public getTaskSettingsDetail(fetch?: boolean) {
    return this._endPointService.call<TaskSettingDetailActor[]>(
      'GetTaskSettingsDetail',
      null,
      fetch
    );
  }

  public saveTaskSettingsDetail(ids: TaskSettingsSave[]): Observable<void> {
    return this._endPointService.call<void>('SaveTaskSettingsDetail', ids, true);
  }

  public saveTaskSettings(map: Map<string, number>) {
    const ids: number[] = [];
    map.forEach((value, key) => {
      ids.push(value);
    });
    this._endPointService.call<void>('SaveTaskSettings', ids, true);
  }

  public SetReviewedByStudent() {
    this._endPointService.call('SetReviewedByStudent', null, false);
  }
}
